import { NavLink } from 'react-router-dom'
import {
  HomeIcon,
  RectangleStackIcon,
  ChartBarIcon,
  UsersIcon,
  Cog6ToothIcon,
  UserGroupIcon,
  ClipboardDocumentListIcon,
  TrophyIcon,
  ChatBubbleLeftRightIcon,
  DocumentTextIcon
} from '@heroicons/react/24/outline'
import { useAuth } from '../../contexts/AuthContext'
import { AdjustmentsHorizontalIcon } from '@heroicons/react/20/solid'


function Sidebar({ isOpen,userRole }) {
  const { user } = useAuth()

  const getNavigationItems = () => {
    if (!userRole?.role_name) return []

    switch (userRole.role_name) {
      case 'Admin':
        return [
          { name: 'Landing', href: '/landing', icon: HomeIcon },
          { name: 'Dashboard', href: '/dashboard', icon: HomeIcon },
          { name: 'Applications', href: '/applications', icon: Cog6ToothIcon },
          { name: 'Progress & Analytics', href: '/progressandanalytics', icon: ChartBarIcon },
          { name: 'User Management', href: '/management/users', icon: UsersIcon },
          { name: 'Data Access Control', href: '/dataaccesscontrol', icon: AdjustmentsHorizontalIcon },
          { name: 'Reports', href: '/reports', icon: DocumentTextIcon },
        ]

      case 'Educator':
        return [
          { name: 'Landing', href: '/landing', icon: HomeIcon },
          { name: 'Dashboard', href: '/dashboard', icon: HomeIcon },
          { name: 'My Applications', href: '/educatorapplications', icon: RectangleStackIcon },
          { name: 'Progress & Analytics', href: '/progressbar', icon: ChartBarIcon },
          { name: 'Add Notes & Grades', href: '/addnotesgrades', icon: ClipboardDocumentListIcon },
          { name: 'Student Management', href: '/studentmanagement', icon: UsersIcon },
          // { name: 'My Classes', href: '/classes', icon: UserGroupIcon },
          { name: 'Reports', href: '/educatorprogressandandanalytics', icon: DocumentTextIcon },
        ]

      case 'Student':
        return [
          { name: 'Landing', href: '/landing', icon: HomeIcon },
          { name: 'Dashboard', href: '/dashboard', icon: HomeIcon },
          { name: 'My Applications', href: '/myapplications', icon: RectangleStackIcon },
          { name: 'My Progress', href: '/trackprogress', icon: ChartBarIcon },
          // { name: 'Assignments', href: '/assignments', icon: ClipboardDocumentListIcon },
          // { name: 'Achievements', href: '/achievements', icon: TrophyIcon },
        ]

      case 'Family':
        return [
          { name: 'Landing', href: '/landing', icon: HomeIcon },
          { name: 'Dashboard', href: '/dashboard', icon: HomeIcon },
          { name: 'Child Progress', href: '/progressbar', icon: ChartBarIcon },
          // { name: 'My Children', href: '/students', icon: UserGroupIcon },
          { name: 'Applications', href: '/myapplications', icon: RectangleStackIcon },
          // { name: 'Communication', href: '/messages', icon: ChatBubbleLeftRightIcon },
        ]

      default:
        return [
          { name: 'Dashboard', href: '/dashboard', icon: HomeIcon },
        ]
    }
  }

  const navigation = getNavigationItems()

  const getRoleColor = () => {
    switch (userRole?.role_name) {
      case 'Admin': return 'text-blue-600 bg-blue-50'
      case 'Educator': return 'text-green-600 bg-green-50'
      case 'Student': return 'text-purple-600 bg-purple-50'
      case 'Family': return 'text-orange-600 bg-orange-50'
      default: return 'text-gray-600 bg-gray-50'
    }
  }

  const getRoleName = () => {
    switch (userRole?.role_name) {
      case 'Admin': return 'Administrator'
      case 'Educator': return 'Educator'
      case 'Student': return 'Student'
      case 'Family': return 'Family'
      default: return 'User'
    }
  }

  return (
    <aside
      className={`bg-white shadow-sm border-t-8 border-brandYellow min-h-screen transition-all duration-300
        ${isOpen ? 'w-[250px]' : 'w-16'}
      `}
    >
      {/* <div className="fixed top-0    border-b-8 border-brandYellow py-5 z-10"></div> */}
      <nav className="mt-8 px-2">
        <ul className="space-y-2">
          {navigation.map((item) => (
            <li key={item.name}>
              <NavLink
                to={item.href}
                className={({ isActive }) =>
                  `group flex items-center h-[65px] px-4 py-4 text-[16px] font-medium rounded-md transition-colors duration-200 ${isActive
                    ? 'bg-brandBlue text-white'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                  }`
                }
              >
                <item.icon
                  className="h-[24px] flex-shrink-0"
                  aria-hidden="true"
                />
                {/* Show text only if open */}
                {isOpen && (
                  <span className="ml-3">{item.name}</span>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  )
}

export default Sidebar



